module.exports = {
  "下载":"Transferir",
  "打开":"Aberto",
  language: {
    "name":"简体中文",
    "title":"选择语言",
    subList: [
      {
        name:"English",
        link:"en",
      },
      // {
      //   name:"简体中文",
      //   link:"zh",
      // },
      {
          name:"繁體中文",
          link:"tw",
      },
      {
        name:"日本語",
        link:"jp",
      },
      {
        name:"한국어",
        link:"kr",
      },
      {
        name:"ไทย",
        link:"th",
      },
      {
        name:"Tiếng Việt",
        link:"vn",
      },
      {
        name:"Español",
        link:"es",
      },
      {
        name: 'Deutsch',
        link: 'de',
      },
      {
        name: 'Français',
        link: 'fr',
      },
      {
        name: 'Italia',
        link: 'it',
      },
      {
        name: 'Portugal',
        link: 'pt',
      },
      {
        name: 'Расея',
        link: 'ru',
      },
      {
        name: 'عربي',
        link: 'ar',
      },
    ]
  },
  "user":{//my
    "wdtd":"Minha equipe",
    "wdyj":"A minha performance",
    "ren":"pessoa",
  },
  "kjsy": {
    "title":"Rendimentos",
    "fxsy":"Partilhar receita",
    "zjlsl":"Valor total da recompensa",
    "jl":"Recompensa",
    "sj":"Data",
    "sl":"Quantidade",
    "sm":"Descrição",
  },
  pay:{//purchase
    "title":"Comprar máquina de mineração",
    "gmsl":"Quantidade de compra",
    "zf":"Pagamento",
    "kyye":"Saldo disponível",
    "kyyebz":"Saldo disponível insuficiente",
    "bztbtips":"O valor de levantamento da entrada é inferior ao requisito mínimo de levantamento desta moeda",
    "bztbtips2":"O valor do levantamento não pode ser inferior ao valor mínimo de levantamento",
    "qsrjymm":"Introduza uma palavra-passe de transação de 6 dígitos",
    "wxts":"Lembrete",
  },
  chongbi:{
    "title":"Depósito",
    "lianmc":"Tipo de corrente",
    "scl":"Gerar cadeia exclusiva",
    "sy":"Chave privada",
    "ewm":"Código QR",
    "bcewm":"Guarde o código QR",
    "cbdz":"Endereço de depósito",
    "fz":"Cópia",
    "sl":"Valor do depósito",
    "qsrsl":"Por favor insira o valor do depósito",
    "sjczje":"Valor real da recarga",
    "qsrsjczje":"Por favor, insira o valor real da recarga",
    "pzms":"Descrição do certificado",
    "qsrms":"Por favor, introduza uma descrição",
    "hxz":"Valor de hash",
    "qsrhxz":"Por favor, introduza o valor do hash",
    "pztp":"Imagem do voucher",
    "qscpztp":"Por favor carregue a foto do certificado",
    "fzcg":"Cópia bem-sucedida",
    "yhkcz":"Recarga de cartão bancário",
    "usdtcz":"Recarga USDT",
    "btccz":"Recarga BTC",
    "xzbz":"Selecione a moeda",
    "sure":"Confirmar",
    "ck":"Ver",
    "tips1":"Não carregue nenhum ativo que não esteja nesta moeda para o endereço acima, caso contrário os ativos não poderão ser recuperados",
    "tips2":"1. A sua rede de envio e a plataforma de destino são consistentes; se escolher que o endereço de destino seja a rede Ethereum, deverá selecionar a cadeia inteligente correspondente ao enviar. Se houver um erro, não poderá recuperar os seus ativos digitais.",
    "tips3":"2.Assegure-se de que o seu endereço e rede são consistentes antes de enviar.",
    "tips4":"Lembrete: devido ao anonimato e à privacidade da rede blockchain, se introduzir informações incorretas, perderá os ativos correspondentes. Não deixe de verificar o seu endereço de entrega.",
  },
  usdttb:{
    "title":"Retirar",
    "lmc":"Tipo de corrente",
    "xzl":"Selecione a cadeia",
    "xztbdz":"Selecione o endereço de levantamento",
    "qsrtbdz":"Por favor, introduza o endereço de levantamento",
    "tbdz":"endereço de levantamento",
    "qsrdz":"Por favor, introduza o endereço",
    "tbsl":"Valor de levantamento",
    "tbsl2":"Valor de levantamento",
    "qsrtbsl":"Por favor, insira o valor do levantamento",
    "sjtxje":"Valor real da retirada",
    "qsrsjtxje":"Por favor, insira o valor real da retirada",
    "dzje":"Valor da conta",
    "jymm":"Senha de transação",
    "qsrjymm":"Por favor, introduza a palavra-passe da transação",
    "sxf":"Taxa de manuseamento",
    "qsrsxf":"Por favor, introduza a taxa de manuseamento",
    "dzsl":"Valor da conta",
    "dzsl2":"Valor da conta recebida:",
    "qsrdzsl":"Por favor insira o valor da conta",
    "wxts":"Lembrete:",
    "mrzdtxcs":"Valor mínimo de levantamento de cada vez:",
    "hxxf":"Precisa de consumir",
    "cktx":"Disponível apenas para levantamento",
    "ci":"Tempos",
    "wddtxyq":"Requisitos de retirada não cumpridos",
    "tjcg":"Envio bem-sucedido, aguarde a revisão",
    "tips":"Só pode levantar moedas se o seu próprio poder de computação for superior a 1T (exceto para o poder de computação de máquina de mineração experiente) ou se o poder de computação sob o guarda-chuva for superior a 50T.",
    "dz":"Morada",
    "qd":"OK",
    "zdtb":"Retirada mínima",
  },
  kefu: {
    "title":"Entre em contacto com o serviço de apoio ao cliente",
    "zxkf":"Atendimento ao Cliente",
    "fzcg":"Cópia bem-sucedida",
  },
  xgdlmm:{//Modify login password
    "title":"Alterar a palavra-passe de login",
    "t1":"Palavra-passe de login atual",
    "t2":"Por favor, introduza a palavra-passe de login atual",
    "t3":"Nova Senha",
    "t4":"Por favor, introduza 6 a 16 dígitos e letras",
    "t5":"Confirme a sua senha",
    "t6":"Por favor, introduza 6 a 16 dígitos e letras",
    "t7":"Confirmar",
    "t8":"A palavra-passe é inconsistente com a palavra-passe de confirmação",
    "mm":"Palavra-passe",
    "qsrmm":"Por favor, introduza a sua senha",
    "qqrmm":"Por favor confirme a sua palavra-passe",
    "qsrsjh":"Número de telemóvel",
    "zc":"Registar",
    "mmts":"Comprimento da palavra-passe: 6 a 12 caracteres",
  },
  sztxmm:{//Set withdrawal password
    "title":"Alterar a palavra-passe da transação",
    "wjtkmm":"Esqueceu-se da senha da transação",
    "qsrjdlmm":"Por favor, introduza a palavra-passe da transação atual",
    "zh":"Conta",
    "qsryxhzsj":"Por favor, introduza o seu endereço de e-mail ou telemóvel",
    "t1":"Palavra-passe da transação atual",
    "t2":"Nova palavra-passe de transação",
    "t3":"Por favor, introduza a palavra-passe de transação de 6 dígitos",
    "t4":"Confirme a sua senha",
    "t5":"Esqueceu-se da senha da transação?",
    "t6":"Confirmar",
    "t7":"A palavra-passe é inconsistente com a palavra-passe de confirmação",
    "t8":"Palavra-passe da transação",
    "yzm":"Código de verificação",
    "qsryzm":"Por favor, introduza o código de verificação",
    "hqyzm":"Obter código de verificação",
  },
  record: {
    "cbjl":"Registo de depósito",
    "tbjl":"Registo de retirada",
    "status":"['Não revisto','Aprovado','Rejeitado']",
    "bhly":"Motivo da rejeição",
    "ldz":"Morada",
    "cjsj":"Tempo de criação",
    "zzsj":"Tempo de transferência",
    "czl":"Cadeia de recarga",
    "zrl":"Cadeia de transferência",
    "jyhx":"Hash de transação",
  },
  yqm: {
    "wdyqlj":"O meu link de convite",
    "wdyqm":"O meu código de convite",
    "schbyq":"Gerar convite para poster",
    "bctp":"Guardar imagem",
    "qx":"Cancelar",
    "fx":"Partilhar",
    "yqm":"Copiar código de convite",
    "bcewmdxc":"Guarde o código QR no álbum",
    "bcbd":"Guardar local",
  },
  "wdtd": {
    "title":"Minha equipe",
    "td":"Equipa",
    "yqhy":"Convidar amigos",
    "ren":"Pessoa",
    "wdtdzrs":"O número total da minha equipa",
    "uid":"ID único:",
    "zh":"Conta:",
    "tdrs":"Tamanho da equipa:",
    "zcsj":"Data de inscrição:",
  },
  "wdyj": {
    "title":"A Minha Performance",
    "wdyd":"A minha geração",
    "dyj":"Desempenho",
    "tdzyj":"Desempenho total da equipa",
    "uid":"ID único:",
    "tdrs":"Tamanho da equipa:",
    "yj":"Desempenho:",
  },
  "zc": {
    "title":"Ativos",
    "zzczh":"Total de ativos equivalentes",
    "dh":"Câmbio",
    "yczc":"Ativos ocultos como 0",
    "xj":"Preço atual",
    "zh":"Convertido",
    "zcmx":"Detalhes do ativo",
  },
  "duihuang": {
    "title":"Câmbio",
    "hl":"Taxa de câmbio",
    "zf":"Pagamento",
    "qbdh":"Trocar tudo",
    "ky":"Disponível",
    "dd":"Obter",
    "ljdh":"Resgatar agora",
    "cont":"Variações da taxa de câmbio, sujeitas ao valor efetivamente recebido",
    "yebz":"Saldo insuficiente",
    "ksslbz":"Quantidade disponível insuficiente",
    "qtxje":"Por favor, introduza a quantidade",
    "dhcg":"Troca bem-sucedida",
    "mrcg":"Compre com sucesso",
    "mccg":"vendido com sucesso",
    "wtcg":"Delegação bem-sucedida",
    "ts":"Imediato",
    "btcmTips":"De acordo com as configurações do contrato inteligente, a troca de USDT no GDCC terá início a 8 de agosto de 2023.",
    "qx":"Cancelar",
  },
  "sign": {
    "title":"Entre para receber moedas",
    "title2":"Recompensa de login diário",
    "title3":"Recompensa de login",
    "qd":"Entrar",
    "yqd":"Assinado em",
    "hdgz":"Detalhes da regra",
    "qdjl":"Registo de check-in",
    "qdcg":"Entrar com sucesso",
  },
  "langNew": {
    "wd":"Meu",
    "jd":"Empréstimo",
    "jghy":"Futuros",
    "xbsg":"Compra de moeda de Singapura",
    "sylx":"Tipo de benefício",
    "syts":"Dias de ganhos",
    "rsy":"Renda diária",
    "rsy2":"Renda diária",
    "yjdts":"Número de dias emprestados",
    "jdsy":"Empréstimos de rendimento",
    "jdsy2":"Empréstimos de rendimento",
    "jdrq":"Data do empréstimo",
    "qdsy":"Benefícios do Login",
    "tgsy":"Benefício de promoção",
    "sybl":"Taxa de lucro",
    "sybl2":"Taxa de lucro",
    "ljcy":"Junte-se agora",
    "zsy":"Rendimento total do USDT",
    "jdrz":"Nó de ligação",
    "jiedian":"nó",
    "qsrje":"Por favor insira um nó",
    "xyb":"Seguinte",
    "zhye":"Saldo da conta",
    "dzye":"Endereço Saldo",
    "zhyezh":"Saldo da conta (equivalente)",
    "zq":"Período:",
    "zq2":"período",
    "jdsl":"Valor do empréstimo",
    "yxbd":"Verificação de e-mail",
    "qsryxzh":"Por favor, introduza a sua conta de e-mail",
    "yxgz":"O endereço de e-mail introduzido não está de acordo com as regras",
    "jxz":"Em curso",
    "ywc":"Concluído",
    "day":"Dias",
    "jg":"Preço",
    "zwsj":"Sem dados~",
    "wyjb":"Emprestar",
    "fxjl":"Partilhar Recompensa",
    "aqsz":"Configurações de segurança",
    "wded":"A minha segunda geração",
    "wdsd":"As minhas três gerações",
    "dbxe":"Limite de transação única",
    "tjdd":"Enviar pedido",
    "tqsh":"Retirar Redenção",
    "shuhui":"Redenção",
    "ljdz":"Endereço do link",
    "yyqh":"Troca de idioma",
    "zxkf":"Atendimento ao Cliente",
    "syl":"Retorno diário",
    "zhuanbi":"Ganhe moedas",
    "zbsy":"Ganhe rendimento em moeda",
    "mc":"Nome",
    "zxj":"Último preço",
    "zfb":"Lista em ascensão",
    "shouye":"Página inicial",
    "gg":"Anúncio",
    "rzz":"Certificando",
    "yrz":"Autenticado",
    "rzsb":"A autenticação falhou, por favor autentique novamente",
    "cxrz":"Reautenticação",
    "jymmts":"Por favor, defina uma palavra-passe de transação",
  },
  "xbsg":{
    "title":"Nova moeda",
    "wdsg":"Detalhes",
    "scts":"Dias de confinamento:",
    "sy":"Restante",
    "ljsg":"Assine agora",
    "ysk":"Esgotado",
    "xzjdy":"Assine agora",
    "dy":"Inscrever-se",
    "fxjg":"Preço de emissão",
    "fxl":"Circulação",
    "ssrq":"Data de listagem",
    "yxqx":"Período de validade",
    "qsrsl":"Por favor, introduza o valor",
    "syl":"Restante",
    "sgrq":"Inscrever-se",
    "sgsl":"Montante",
    "bz":"Moeda",
    "yebz":"Saldo USDT insuficiente",
    "tgsl":"Qtde de passagem",
    "shz":"Em revisão",
    "wtg":"Não passou",
    "ytg":"Passou",
  },
  "wydb":{
    "title":"Emprestar",
    "db":"Emprestar",
    "dbz":"Emprestar",
    "jl":"Registo",
    "jdzq":"Período (dias)",
    "qhk":"Para retribuir",
    "ljdb":"Acumulado (usdt)",
    "dhkbs" :"Pagamento pendente",
    "jkje":"Montante do empréstimo (usdt)",
    "qsrje":"Por favor, introduza o valor",
    "rll":"Taxa de juro diária",
    "hkfs":"Reembolso",
    "dqych":"Expirado",
    "lx":"Interesse",
    "fkjg":"Emprestador",
    "tpsc":"Empréstimo de crédito (upload de imagem)",
    "fwxx":"Informações sobre habitação",
    "srzm":"Comprovativo de rendimentos (relação de trabalho)",
    "yhmx":"Extrato bancário",
    "zjz":"Foto de identificação",
    "yd":"Eu li e concordo",
    "xy":"Solicitar um contrato de empréstimo",
    "sqdb":"Clique para solicitar cadeias de empréstimos",
    "gb":"Perto",
    "qd":"OK",
    "ts":"Por favor, assinale Solicitar um contrato de empréstimo",
    "dbjl":"Registo",
    "hkhth":"Código do pedido",
    "wsh":"Não revisto",
    "yfk":"Empréstimo",
    "sqrq":"Tempo de aplicação",
    "zq":"Ciclo",
    "dbsl":"Número de costelas",
    "zhke":"Pagamento total",
    "yhkxq":"Detalhes de Reembolso",
    "bqyhk":"Reembolsável no período corrente (USDT)",
    "hktips":"Certifique-se de que o saldo é suficiente. Se o saldo for insuficiente, recarregue primeiro e depois pague novamente.",
    "bj":"Principal",
    "jie":"Emprestar",
    "ljhk":"Pagar imediatamente",
    "qcz":"Para depositar",
    "yebzqxcz":"Saldo insuficiente, recarregue primeiro e depois pague",
    "znj":"Taxa de pagamento em atraso",
    "yqts":"Dias de atraso",
  },
  "hkxq":{
    "dd":"Encomenda",
    "fzhkdz":"Copie o endereço de reembolso",
    "hkxq":"Detalhes de Reembolso",
    "zlx":"Juros totais",
    "zhk":"Reembolsos totais",
    "hkjg":"Agência de reembolso",
    "qschkpz":"Por favor, carregue o certificado de reembolso",
    "hkpz":"Certificado de reembolso",
  },
  "kxt":{
    "gao":"E",
    "di":"eu",
    "wtgd":"Encomenda",
    "cj":"Negócio",
    "jj":"Informações",
    "sj":"Hora",
    "fx":"Direção",
    "jg":"Preço",
    "sl":"Quantidade",
    "mr":"Comprar",
    "mc":"Vender",
    "mp":"Licitação",
    "sp":"Vendendo",
    "slb":"Qtd.",
    "fhsj":"Data de emissão",
    "fhsl":"Número de emissão",
    "bps":"Livro Branco",
    "gw":"Site oficial",
    "fz":"mínimo",
    "xs":"hora",
    "tian":"dias",
    "zhou":"semana",
    "yue":"mês",
    "gd":"Mais",
    "ft":"Subgráfico",
    "zt":"Gráfico principal",
    "sdt":"Imagem de profundidade",
    "zx":"Favoritos",
    "djck":"Clique para ver",
  },
  "jghy":{
    "jghy":"Opções",
    "yxhy":"Perpétuo",
    "mz":"Comprar Longo",
    "md":"Comprar a descoberto",
    "gmj":"Preço de compra",
    "jsj":"Preço de liquidação",
    "xj":"Preço atual",
    "fx":"Direção",
    "sl":"Volume",
    "jgsj":"Prazo de entrega",
    "gb":"Perto",
    "jxxd":"Continue a fazer um pedido",
    "cclb":"Lista de pedidos",
    "zc":"Atual",
    "lscc":"História",
    "qblx":"Tudo",
    "yk":"Lucro",
    "ddqr":"Confirmação do pedido",
    "dqsj":"Tempo de expiração",
    "jssj":"Prazo de entrega",
    "sy":"Lucro",
    "tzje":"Preço do investimento",
    "zdje":"Preço mais baixo 0",
    "kyye":"Equilíbrio",
    "kyye2":"Equilíbrio",
    "sxf":"Taxa:",
    "sxfl":"Taxa",
    "jypz":"Nome",
    "jyfx":"Direção",
    "qrxd":"Confirmar",
    "fs":"Linha",
    "dqye":"Saldo atual",
  },
  "zhjl":{
    "title":"Histórico de ativos",
    "cbtb":"Depósito e levantamento",
    "jymx":"Histórico de transações",
    "tgyj":"Comissão de promoção",
    "wwc":"Desfeito",
    "ywc":"Concluído",
  },
  "tipsNew":{
    "wjmmts":"Recuperar palavra-passe por código de verificação",
    "qscpztp":"Por favor carregue a imagem do voucher",
    "emailgsts":"As caixas de entrada não estão em conformidade com as regras",
    "telgsts":"O número de telemóvel está incorreto",
    "lcmmbyz":"Por favor confirme a sua palavra-passe",
    "zdsl":"Quantidade mínima",
    "sldydy":"Quantidade superior ou igual a",
    "zxtzsl":"Quantidade mínima",
    "ddz":"Espera",
    "xs":"Hora",
    "min":"Quantidade mínima",
    "max":"Quantidade máxima",
    "yebz":"Saldo insuficiente",
    "qsrss":"Por favor insira muitos",
    "zdss":"Lotes mínimos",
    "yjj":"Rejeitado",
    "shz":"Redenção",
    "zwkfcz":"Esta moeda não está aberta a depósito",
    "jiaoge":"Entrega",
    "zhang":"Longo",
    "die":"Curto",
  },
  "assets": {
    "total":"Conversão de ativos (USD)",
    "avaiable":"Disponível",
    "conversion":"Conversão",
    "canuse":"Disponível",
    "yczc":"Ativos ocultos como 0",
  },
  "status": {
    "statusText":"['falha','espera','sucesso']",
  },
  "langNew2":{
    "zczgz":"Ativos totais",
    "hgx":"Conformidade",
    "yszc":"política de Privacidade",
    "gywm":"Sobre nós",
    "zb":"Arbitragem de IA",
    "mnjy":"Negociação Simulada",
    "xbzq":"Zona monetária de Singapura",
    "flzq":"Centro de recompensas",
    "cjmnzhcg":"Crie uma conta de demonstração com sucesso!",
    "wdzh":"A minha conta",
    "yymnzhts":"Já possui uma conta virtual, por favor não se volte a registar",
    "tcmnzh":"Sair da conta demo",
    "mnzhgz":"Avaliação de conta de demonstração",
    "mnzh":"Conta de demonstração",
    "ljdzsb":"Falha ao ligar ao endereço",
    "ysq":"Autorizado",
  },
  "c2c":{
    "bt":"C2C",
    "bt2":"Serviço de pagamento C2C",
    "cjdd":"Criar pedido",
    "mblc":"Depósito em moeda fiduciária",
    "cjydd":"Criar uma pré-encomenda",
    "xmjfk":"Pagar ao vendedor",
    "tqhb":"Retire a sua moeda digital",
    "ddzt":"Estado do pedido",
    "wdys":"As nossas vantagens",
    "c1":"Negocie ao seu preço preferido",
    "c2":"Compre e venda criptomoedas livremente ao preço que preferir. Compre e venda ofertas existentes ou crie um anúncio comercial para definir o seu preço ideal.",
    "c3":"Taxa de transação baixa",
    "c4":"As transações peer-to-peer (C2C) permitem aos vendedores definir livremente o método de pagamento que desejam de forma transparente, comprando e vendendo criptomoedas através de mais de 700 métodos de pagamento, incluindo transferência bancária e dinheiro.",
    "c5":"Vários métodos de pagamento",
    "c6":"A negociação peer-to-peer (C2C) permite aos vendedores definir livremente o método de pagamento que desejam. Compre e venda criptomoedas com mais de 700 métodos de pagamento, incluindo transferências bancárias e dinheiro.",
    "wpp":"Não correspondido",
    "ypp":"Combinado",
    "ysx":"Expirado",
    "ddh":"Número do pedido",
    "mrje":"Quantidade de compra",
    "mrbz":"Comprar moeda",
    "nssdgj":"País",
    "qsrnssdgj":"Por favor, introduza o país",
    "fkrxm":"Nome do pagador",
    "qsrfkrxm":"Por favor, introduza o nome do pagador",
    "yx":"E-mail",
    "qsryx":"Por favor, introduza o seu endereço de e-mail",
    "mmbz":"Tipo de compra",
    "qxzmmbz":"Selecione o tipo de compra",
    "qxz":"Por favor selecione",
    "fkfs":"Método de pagamento",
    "qtxfkfs":"Por favor preencha o método de pagamento",
    "zh":"Conta",
    "fb":"Tipo de moeda de pagamento",
    "qtxfb":"Por favor preencha o tipo de moeda de pagamento",
    "ngmdje":"Valor da sua compra",
    "qsrje":"Por favor, introduza o valor",
    "wxts":"Lembrete caloroso",
    "dsh":"A ser revisto",
    "ygq":"Expirado",
    "jcwdwt":"Introdução ao C2C",
    "tjpz":"Enviar voucher",
    "ckje":"Valor da partida",
    "qsrckje":"Por favor insira o valor correspondente",
    "tjzzfb":"Transferir cópia",
    "tjjzzm":"Cartão de identificação (frente)",
    "tjjzfm":"Cartão de identificação (verso)",
    "psts1":"Tenha em atenção os seguintes pontos ao fotografar",
    "psts2":"Note que a borda da imagem está completa, a fonte está clara e o brilho é uniforme",
    "psts3":"Por favor, não envie fotos de identificação que não correspondam ao seu nome",
    "qsczzfb":"Por favor, carregue uma cópia da transferência",
    "qscjzzm":"Por favor, carregue a frente da sua carta de condução",
    "qscjzfm":"Por favor, carregue o verso da sua carta de condução",
    "tj":"Submeter",
    "je":"Limite de alcance",
    "ljtg":"Fazer pedido",
    "sp":"Entenda o DEFI",
    "xq":"Detalhes",
    "lxkfppdd":"Entre em contacto com o serviço de apoio ao cliente para combinar o pedido",
    "szgj":"País",
    "qsrszgj":"Por favor insira o seu país",
    "fkyhmc":"Nome do banco de pagamento",
    "qsrfkyhmc":"Por favor, introduza o nome do banco de pagamento",
    "dianhui":"Transferência bancária/Transferência bancária internacional",
    "ccsr":"Entre aqui",
  },
  "xyf":{
    "title":"Pontuação de crédito",
    "pgsj":"Tempo de avaliação",
  },
  "bbjy":{
    "mr":"Comprar",
    "mc":"Vender",
    "mai":"Compra",
    "sell":"Vender",
    "xj":"Limite",
    "sj":"Mercado",
    "pk":"Posição",
    "jg":"Preço",
    "sl":"Qtd.",
    "ss":"Quantidade",
    "mrl":"Volume de compra",
    "mcl":"Volume de vendas",
    "ky":"Disponível",
    "km":"Disponível",
    "ksell":"Comercializável",
    "jye":"Volume de negócios",
    "dqwt":"Atribuição atual",
    "lswt":"Confiança histórica",
    "jj":"Informações",
    "wtzl":"Total",
    "wtjg":"Preço de confiança",
    "ycjl":"Volume de negociação concluído",
    "cjjj":"Preço médio da transação",
    "cd":"Cancelar encomenda",
    "xd":"Encomenda",
    "wqcj":"Um acordo completo",
    "ywc":"Concluído",
    "ycd":"Pedido cancelado",
    "zx":"Favoritos",
    "scjg":"Preço de mercado",
    "fhsj":"Data de emissão",
    "fhsl":"Número de emissão",
    "bps":"Livro Branco",
    "gw":"Site oficial",
    "qx":"Cancelar",
    "bbjy":"Câmbio",
  },
  "hyjy":{
    "mai":"Compra",
    "sell":"Vender",
    "kc":"Posições abertas",
    "pc":"Posições próximas",
    "cc":"Posições",
    "kp":"Perto",
    "kpc":"Fechar curto",
    "kcc":"Posições",
    "kkd":"Aberto longo",
    "kpd":"Longo perto",
    "kkk":"Aberto curto",
    "xj":"Limite",
    "sj":"Mercado",
    "xjwt":"Ordem de limite",
    "sjwt":"Preço de mercado",
    "pk":"Posição",
    "jg":"Preço",
    "sl":"Qtd.",
    "gg":"Alavanca",
    "tzgg":"Alavanca de controlo",
    "ggbs":"Alavancar",
    "mrl":"Volume de compra",
    "ky":"Disponível",
    "jye":"Volume de negócios",
    "dqwt":"Atribuições atuais",
    "lswt":"Confiança histórica",
    "ptwt":"Encarregamentos ordinários",
    "dqwtmr":"Atribuições atuais (Comprar)",
    "dqwtmc":"Atribuições atuais (Vender)",
    "hywt":"Atribuições de contrato",
    "jj":"Informações",
    "wtzl":"Total",
    "wtjg":"Preço de confiança",
    "ycjl":"Volume de negociação concluído",
    "cjjj":"Preço médio da transação",
    "qbcd":"Retirar todos os pedidos",
    "cd":"Cancelar encomenda",
    "xd":"Encomenda",
    "wqcj":"Um acordo completo",
    "ywc":"Concluído",
    "ycd":"Pedido cancelado",
    "zx":"Favoritos",
    "scjg":"Preço de mercado",
    "fhsj":"Data de emissão",
    "fhsl":"Número de emissão",
    "bps":"Livro Branco",
    "gw":"Site oficial",
    "mrzd":"Aberto há muito tempo",
    "mrpk":"Fecho curto",
    "mczk":"Curto aberto",
    "mcpd":"Longo perto",
    "mrkdkz":"Abertura longa (alta)",
    "mrpkkz":"Fecho curto (altista)",
    "mckkkd":"Abertura curta (pessimista)",
    "mcpdkd":"Fecho longo (pessimista)",
    "yxhy":"Contrato perpétuo",
    "dc":"Posições longas",
    "kcjj":"Preço médio da posição aberta (BUSDT)",
    "wsxyl":"Lucro não realizado (BUSDT)",
    "ygqpj":"Paridade forte estimada (BUSDT)",
    "syl":"Renda diária",
    "cwbzj":"Margem de posição (BUSDT)",
    "cw":"Posições (Nº)",
    "cwjz":"Valor da posição (BUSDT)",
    "bzjl":"Taxa de margem",
    "kpz":"Fechar (N.º)",
    "bdzs":"Índice subjacente",
    "tzbzj":"Ajustar margem",
    "zyzs":"Take profit e stop loss (obter lucro e parar perdas)",
    "zjbzj":"Aumentar margem",
    "jsbzj":"Reduzir margem",
    "tyhy":"Contrato de experiência",
    "ccz":"Posição (N.º)",
    "cwbzjt":"Margem de posição (TBTC)",
    "zdzjbzj":"Aumento máximo da margem (TBTC)",
    "zjbzjt":"Aumento de margem (TBTC)",
    "zhang":"Qtd.",
    "qblx":"Todos os tipos",
    "qb":"Tudo",
    "ccjg":"Posições preço",
    "ccsl":"Posições Qtd.",
    "yk":"Lucro e perda",
    "ccsj":"Posições tempo",
    "zy":"Tirar lucro",
    "zs":"Parar perda",
    "zje":"Montante total",
    "kcs":"Posições abertas Qtd.",
    "kcjg":"Preço das posições abertas",
    "ss":"Muitos",
    "hand":"1 lote =",
    "qx":"Cancelar",
    "qr":"OK",
  },
  "bbjyNew":{
    "jylx":"Tipos de",
    "jyze":"Montante",
  },
  "langNew3":{
    "bzxq":"Detalhes de tijolos móveis",
    "znbz":"AI Quantitativa Inteligente Tijolo em Movimento",
    "apits":"Ligue-se perfeitamente às APIs de mais de 200 bolsas em todo o mundo",
    "jr":"Juntar",
    "gn":"Função",
    "lhjs":"Introdução à quantificação de dividendos",
    "jqrts":"Como funcionam os robôs?",
    "sctj":"Estatísticas de Mercado",
    "scqk":"Condições de mercado",
    "jiaoge":"Entrega",
    "zhang":"Aumento",
    "die":"Outono",
    "sz":"Configurações",
    "qbcp":"Todos os produtos",
    "jrlh":"Junte-se à quantificação de IA",
    "sywd":"0 risco, rendibilidades estáveis",
    "bzbz":"Tipo de encriptação",
  },
  "sztkmm":{
    "title":"Definir senha de levantamento",
    "dlmm":"Senha de login",
    "dlmmts":"Por favor, introduza a senha de login",
    "xmm":"Nova Senha",
    "mmts":"Comprimento da palavra-passe: 6 dígitos",
    "qrmm":"Confirme a sua senha",
    "qr":"OK",
    "qd":"OK",
    "sztkts":"Dica: Vá para a Central de Segurança para definir a palavra-passe da transação",
  },
  "bzhl":{
    "title":"Dividendo",
    "gz":"Regras",
    "tgdd":"Ordem de custódia",
    "zztgdzj":"Fundos sob custódia",
    "yjjrsy":"Estimado diariamente",
    "ljsy":"Renda total",
    "tgzdd":"Ordem de custódia",
    "cljxcp":"Produtos de campanha estratégica",
    "dbxe":"Limite",
    "rsyl":"Taxa de rendibilidade diária",
    "zq":"Ciclo de encomendas",
    "qmr":"Vá e compre",
    "bbzhzc":"Ativos da conta",
    "zcc":"Total do ativo (USDT)",
    "dd":"Pedidos",
    "buy":"Comprar em",
    "jxcp":"Produtos em destaque",
    "ckdd":"Verificar ordem",
    "gd":"Mais",
    "xzbzts":"Simples e seguro. Os dividendos podem ser selecionados em várias moedas",
    "qtbz":"Outras moedas",
    "dj":"Nível",
    "cjwt":"Problemas comuns",
    "ddsl":"Quantidade do pedido",
    "sl":"Montante",
  },
  "bzhlgm":{
    "title":"Lucros com a remoção de tijolos",
    "bzhld":"Lucros da remoção de tijolos USDT",
    "qtzq":"Ciclo de 7 dias do USDT",
    "rsyl":"Rato de retorno diário",
    "lczq":"Ciclo financeiro",
    "dbxe":"Limite",
    "pxsj":"Tempo de pagamento de dividendos",
    "mr":"Diariamente",
    "dqfh":"Devolver quando devido",
    "tgzj":"Capital de custódia",
    "tqsh":"Resgate antecipado",
    "yjsy":"Rendimento antecipado (USDT)",
    "kyzc":"Ativos disponíveis (USDT)",
    "cpjs":"Sobre os nossos produtos",
    "tgje":"Introduza o valor",
    "qsrtgje":"Por favor, insira o valor da custódia",
    "qb":"Tudo",
    "rm":"Clique aqui",
    "cpzq":"Ciclo do produto",
    "jxr":"Data de cálculo dos juros",
    "jiexr":"Data de liquidação de juros",
    "yjdzr":"Data estimada de chegada",
    "gz":"Conheça as regras e os interesses",
  },
  "bzhlwdtg":{
    "title":"Estado do pedido",
    "tgz":"Em custódia",
    "ywc":"Concluído",
    "ysh":"Resgatado",
    "tgje":"Valor da custódia/Tempo de custódia",
    "rsyl":"Rato de retorno diário",
    "yhl":"Lucrou",
    "xdsj":"Tempo de encomenda",
    "sh":"Redenção",
    "ddxq":"Detalhes do pedido",
    "ddh":"Nº do pedido.",
    "syts":"Restante",
    "ddztxq":"Detalhes do estado do pedido",
  },
  "langNew4":{
    "kp":"Abertura",
    "zuoshou":"Recebido ontem",
    "zg":"Mais alto",
    "zd":"Mais baixo",
    "dqjg":"Preço atual",
    "pcjg":"Preço de fecho",
    "gd":"Pedido pendente",
    "gdj":"Preço do pedido pendente",
    "gdjg":"Preço do pedido pendente",
    "xfbzj":"Depósito de segurança necessário",
    "ksrfw":"Gama de entrada disponível",
    "shou":"Muitos",
    "fdjyk":"Resultado líquido flutuante",
    "pcsl":"Quantidade de fecho",
    "cx":"revogar",
    "qrpc":"Confirme para fechar a posição",
    "sx":"Filtro",
    "cz":"Reiniciar",
    "zdl":"Sabia",
    "kccg":"Posição aberta com sucesso!",
    "xzfx":"Escolha a direção",
    "lx":"Tipo",
    "xgcc":"Modificar posição",
    "szzyzs":"Defina stop profit e stop loss",
    "szhb":"Cripto",
    "gjs":"Metal",
    "yy":"Bruto",
    "jy":"Comércio",
    "jmhb":"Cripto",
    "gdsj":"Tempo de encomenda pendente",
    "gdsl":"Quantidade de encomenda pendente",
    "fs":"Hora",
   },
   "deals": {
    "issue_time":"Hora",
    "issue_number":"Número",
    "white_book":"Livro",
    "weburl":"URL->",
    "video_url":"Vídeo",
    "introduction":"Informações",
    "onhand":"uma mão igual",
    "position":"Posição",
    "leverorder":"Alavancagem de ordens",
    "leverposition":"posição alavancada",
    "inputprice":"Preço de entrada",
    "inputmul":"Entrada múltipla",
    "selectmul":"Escolha vários",
    "onehand":"uma mão é igual a",
    "hand":"Número de mãos de negociação",
    "marketval":"Valor de mercado",
    "bond":"Vínculo",
    "service":"taxa de serviço",
    "balance":"equilíbrio",
    "type":"Tipo",
    "risk":"Taxa de risco",
    "total":"lucro total",
    "onekey":"fechando-o",
    "makemore":"(Longo)",
    "makeless":"(Curto)",
    "current":"Ordens abertas",
    "all":"Tudo",
    "weing":"Em comissão",
    "tding":"Negociação",
    "ping":"Fechamento",
    "pied":"Fechado",
    "ceiled":"retirado",
    "weprice":"preço de comissão",
    "oprice":"Preço de abertura",
    "nowprice":"Preço atual",
    "zyprice":"Preço de paragem de ganhos",
    "zsprice":"Preço de stop-loss",
    "canbond":"Margem disponível",
    "optime":"Horário de funcionamento",
    "pgtime":"Hora de fecho",
    "znum":"Quantidade convertida",
    "gprice":"Taxas de pernoita",
    "pcang":"Perto",
    "revoke":"Levantamento",
    "fee":"Taxa",
    "you":"Preço de mercado ideal",
  },
  "zyzs":{
    "title":"Take profit e stop loss (obter lucro e parar perdas)",
    "zy":"Tirar lucro",
    "zs":"Parar perda",
    "qsrzyjg":"Introduza um preço Take Profit",
    "qsrzsjg":"Por favor, introduza um preço de Stop Loss",
    "cfjglx":"Tipo de preço de disparo",
    "zsjg":"Índice de preços",
    "scjg":"Preço de mercado",
    "pcfs":"Métodos para fechar posições",
    "kpcw":"Liquidação",
    "qbcw":"Todas as posições",
    "wxts":"Observe",
    "cont":"As posições de fecho do preço de mercado podem criar a possibilidade de falha na execução de uma ordem ao preço de mercado, ou de sucesso na obtenção de lucro/stop loss devido a fortes flutuações de mercado e outros problemas.",
    "qr":"OK",
  },
  "level1": {
    "name":"Nome real",
    "idcard":"Tipo de certificado",
    "address":"Endereço de residência atual",
    "bank_number":"Número do banco",
    "wc":"OK",
    "name_nodata":"O nome não pode estar vazio",
    "id_card_nodata":"O número do certificado não pode estar vazio",
    "address_nodata":"O endereço não pode estar vazio",
    "bank_number_nodata":"O número do cartão bancário não pode estar vazio",
    "input-username":"Por favor, insira o seu nome real",
    "zjhm":"Número do certificado",
    "input-idcard":"Por favor, introduza o número do seu certificado",
    "input-address":"Por favor insira o seu endereço",
    "zjlx":"Tipos de identificação válida",
    "qxzzjlx":"Selecione os tipos de ID válidos",
    "sfz":"Cartão de identificação",
    "hz":"Passaporte",
    "jsz":"Carteira de motorista",
    "lxz":"Certificado para estudar no estrangeiro",
    "zfbzh":"Conta Alipay",
    "qsrzfbzh":"Por favor, insira a sua conta alipay",
    "khh":"Abertura de conta",
    "qsrkhh":"Por favor, informe a sua conta bancária",
    "yhkh":"Número do cartão bancário",
    "qsryhkh":"Por favor, introduza o número do seu cartão bancário",
    "zfzh":"Conta de pagamento",
    "qxzzfzh":"Por favor, escolha uma conta de pagamento",
    "gjlb":"Lista de países",
    "qxzgjlb":"Selecione o país / região",
    "gjhdq":"País/Região",
    "qtxgj":"Por favor preencha o país/região",
  },
  "gjrz":{
    "title":"Autenticação KYC",
    "t1":"1.As imagens com menos de 8 MB e nos formatos JPG, JPEG ou PNG são suportadas.",
    "t2":"2.As fotos dos documentos de identificação devem ser nítidas e não devem ser modificadas ou bloqueadas. A foto pessoal, o número do documento e o nome do titular do documento devem estar claramente visíveis.",
    "t3":"3.As fotos devem ser tiradas sem qualquer acessório de cabeça e é recomendado não incluir o uso de maquilhagem. As características faciais do portador do documento devem ser claras e reconhecíveis, e os seus braços devem estar totalmente expostos.",
    "t4":"OK",
    "bh":"Rejeitar",
    "shz":"Em revisão",
    "shtg":"Aprovado",
    "nyrzcg":"Foi certificado com sucesso",
    "sczjz":"Carregar fotos de identificação",
    "sczjzmz":"Carregar foto da frente do documento de identificação",
    "sczjbmz":"Carregar foto do verso do documento de identificação",
    "scgrqmz":"Upload de documentos e assinatura pessoal",
    "wdtjr":"O meu recomendador",
    "tjrid":"ID do recomendador",
    "qsrtjrid":"Por favor, introduza o ID do recomendador",
    "idbcz":"O ID do referenciador não existe",
    "tjcg":"Envio bem-sucedido",
    "tjridts":"O ID do recomendador não pode ser preenchido por si",
    "qsrzh":"Por favor insira a conta",
    "dl":"Conecte-se",
    "jc":"Pobre",
    "yb":"General",
    "yx":"Excelente",
    "ldjsqh":"Futuros LME",
    "wh":"Câmbio Estrangeiro",
  },
  "newReg":{
    "sjh":"Móvel",
    "yx":"E-mail",
    "yqm":"Código de convite",
    "yqm2":"Código de convite (opcional)",
    "cjzh":"Criar uma conta",
    "sysjhzyx":"Registe-se com número de telemóvel/e-mail",
    "sj":"Móvel",
    "yhxy":"",
    "yhxy2":"Li e concordo com o  e  ",
    "hmyzh":"Ainda não tem conta?",
    "qzc":"Registar",
    "qbdl":"Login na carteira",
    "qyqbfw":"Por favor, utilize a APP da carteira para aceder",
    "dc":"Sair",
    "cycs":"Número de participações"
  },
}



// WEBPACK FOOTER //
// ./src/utils/lang/pt.js